import _ from 'lodash';

// NOTE // getting current load capacity based on passenger count and original max load
const getLoadCapacity = (dep) => {
  let originalLoad = dep.Load
  let newLoad = dep.Load
  if (originalLoad && typeof originalLoad === 'string' && originalLoad.includes('/') && dep.passengers && Array.isArray(dep.passengers)) {
    newLoad = originalLoad.split('/')
    newLoad.splice(0, 1, (dep.passengers.length + ''))
    newLoad = newLoad.join('/')
  }
  return newLoad
}

// NOTE // if the dates are the same we need to remove the pax from the original flight, and add the pax to the new flight, as well as recalculate load capacity
export const movePaxSameDay = (listCopy, to, from, rlocs) => {
  let flightToLoc = listCopy.findIndex(flt => flt.FlightNumber === to)
  let flightFromLoc = listCopy.findIndex(flt => flt.FlightNumber === from)
  let flightTo = _.cloneDeep(listCopy[flightToLoc])
  let flightFrom = _.cloneDeep(listCopy[flightFromLoc])

  for (let i = 0; i < rlocs.length; i++) {
    const rloc = rlocs[i];
    // NOTE // grab all the passengers for this rloc from the original flight
    let paxArr = flightFrom.passengers.filter(pax => pax.PNRRefNo === rloc)
    // NOTE // add the passengers to the new flight OR create a passenger array with the passengers to the new flight
    flightTo.passengers = flightTo.passengers && Array.isArray(flightTo.passengers) ? flightTo.passengers.concat(paxArr) : paxArr
    // NOTE // changing the flight number for the moved pax (mostly so they can be moved again)
    flightTo.passengers.forEach(pax => pax.FLTNO = to)
    // NOTE // remove the moved passengers from the original flight
    flightFrom.passengers = flightFrom.passengers.filter(pax => pax.PNRRefNo !== rloc)
  }

  // NOTE // changing the load capacity for the flights
  flightFrom.Load = getLoadCapacity(flightFrom)
  flightTo.Load = getLoadCapacity(flightTo)

  // NOTE // adjust the listCopy to match the modified flights
  listCopy[flightFromLoc] = flightFrom
  listCopy[flightToLoc] = flightTo

  return listCopy
}

// NOTE // if the pax are being moved from one day to another, we only need to adjust the original by removing the moved pax
export const movePaxDifDay = (listCopy, from, rlocs) => {
  let flightLoc = listCopy.findIndex(flt => flt.FlightNumber === from)
  let flight = _.cloneDeep(listCopy[flightLoc])

  for (let i = 0; i < rlocs.length; i++) {
    const rloc = rlocs[i];
    if (flight.passengers && Array.isArray(flight.passengers)) {
      flight.passengers = flight.passengers.filter(pax => pax.PNRRefNo !== rloc)
    }
  }

  flight.Load = getLoadCapacity(flight)
  listCopy[flightLoc] = flight

  return listCopy
}